export enum ModalState {
  REDEEM_IMMEDIATELY = "REDEEM_IMMEDIATELY",
  REDEEM_UNPAUSE_DATE = "REDEEM_UNPAUSE_DATE",
  INITIAL_REDEMPTION = "INITIAL_REDEMPTION",
}
